import { IHttpErrorPayload } from '@fpx/core';
  
export interface ApplicationstatusMaintanence {
  applicationstatus?: Applicationstatus[],
  totalRowCount?:number
  data?: Applicationstatus[],
  
}
export interface Applicationstatus  {
         lastName:string, 
         mobile:string, 
         dateOfBirth:string, 
         authOn:string, 
         createdOn:string, 
         firstName:string, 
         requestRef:string, 
         modifiedOn:string, 
         authBy:string, 
         createdBy:string, 
         appRef:string, 
         processCode:string, 
         requestDate:string, 
         appStatusDesc:string, 
         middleName:string, 
         modifiedBy:string, 
         email:string, 
         status:string, 
  }
  
  
 export interface ApplicationstatusResponse {
    inventoryNo? : string ;
    httpStatus? : number;
    error? : IHttpErrorPayload;
}	
